import {
    useCallback,
    useState,
} from "react"

import { ArrowRightIcon } from "@l2r-front/l2r-icons"
import { Typography } from "@l2r-front/l2r-ui"

import { SubNetworksSelector } from "../SubNetworksSelector"

import * as Styled from "./NetworkSubMenu.styled"

export const NetworkSubMenu = function NetworkSubMenu(
    props,
) {
    const {
        className,
        network,
        activeSubNetworks,
        onClick,
        onChange,
        onClose,
        ...MenuItemProps
    } = props

    const [subAnchorEl, setSubAnchorEl] = useState(null)

    const subOpen = Boolean(subAnchorEl)

    const handleMouseLeave = useCallback((network, selectedSubNetworks) => {
        setSubAnchorEl(null)
        onClose?.(network.slug, selectedSubNetworks)
    }, [onClose])

    return (
        <>
            <Styled.DropdownMenuItem
                className={className}
                onMouseEnter={(e) => setSubAnchorEl(e.currentTarget)}
                onMouseLeave={() => setSubAnchorEl(null)}
                onClick={onClick}
                {...MenuItemProps}
            >
                <Typography>{network.name}</Typography>
                <ArrowRightIcon />
            </Styled.DropdownMenuItem>

            <SubNetworksSelector
                network={network}
                activeSubNetworks={activeSubNetworks}
                style={{ pointerEvents: "none" }}
                anchorEl={subAnchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={subOpen}
                onMouseEnter={() => setSubAnchorEl(subAnchorEl)}
                onMouseLeave={handleMouseLeave}
                onChange={onChange}
            />
        </>
    )
}